import {useMemo} from "react";

export function useNumberInputRules({min, max}: {min?: number; max?: number} = {}) {
    return useMemo(
        () => ({
            pattern: {
                value: /^\d+(\.\d+)?$/,
                message: "Please enter a valid number"
            },
            ...(typeof min === "number"
                ? {min: {value: min, message: `This must be greater than ${min}`}}
                : {}),
            ...(typeof max === "number"
                ? {max: {value: max, message: `This must be less than ${max}`}}
                : {})
        }),
        [min, max]
    );
}
